import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCoin } from "@tabler/icons-react";

export default function CostFilter({
  selected,
  setSelected,
  customData = undefined,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  customData?: Item[];
}) {
  let data: Item[] = [];
  if (customData) {
    data = customData;
  } else {
    for (let i = 0; i < 11; i++) {
      let cost = i;
      data.push({ key: String(cost), value: String(cost) });
    }
  }

  return (
    <GenericFilter
      classNames="w-[100px]"
      selected={selected}
      selectionMode="single"
      setSelected={setSelected}
      label="Cost"
      startContent={<IconCoin height={30} width={30} />}
      data={data}
    />
  );
}
